import type { VNode } from 'preact';
import { Spinner } from '@core/components/Elements';

export interface AppLoadingOverlayProps {
  /** Reserved for compatibility with existing call sites. */
  message?: string;
}

/**
 * Loading overlay used during AR transition and bootstrap.
 * Kept in main entry chunk so it displays immediately in App Clip.
 */
export function AppLoadingOverlay(_: AppLoadingOverlayProps): VNode {
  return (
    <div className="fixed inset-0 z-[70] flex min-h-[100dvh] items-center justify-center bg-white text-black pointer-events-auto">
      <Spinner size="2md" variant="primary" />
    </div>
  );
}
